var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v("Listagem de regiões prazo entrega")]),_c('app-prazo-entrega-paises'),_c('app-prazo-entrega-regioes-pais'),_c('app-prazo-entrega-estados'),_c('app-prazo-entrega-regioes-estado'),_c('app-prazo-entrega-municipios')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }